import React, { useEffect, useState } from "react";
import { Outlet } from 'react-router-dom';
import MainHeader from "../../MainPortal/Header/MainHeader";
import Footer from '../../MainPortal/Footer/Footer';

const MainLayout = () => {

  // useEffect(() => {
  //   setIsLoading(true);
  //   const interval = setInterval(() => {
  //     setIsLoading(false);
  //   }, 2000);
  //   //Clearing the interval
  //   return () => clearInterval(interval);
  // }, []);

  return (
    <>

      <div className="wrapper">
          <>
            <MainHeader />
            <div className="main-wrapper">
              <Outlet />
            </div>
            <Footer />
          </>
      </div>
    </>
  );
};

export default MainLayout;
